import React, { createContext, useState, useEffect } from "react";
import { toast } from "react-toastify";

import moment from "jalali-moment";
import useFetch from "./useFetch";
import { useUserData } from "./UserDataContext";
import { fixNumbers } from "../utils";
import { useLocation } from "react-router-dom";
import { useSetting } from "./SettingContext";
const ProducerBasketContext = createContext();

const ProducerBasketProvider = (props) => {
  const { showNumSix } = useSetting();

  const [userSelectedRing, setUserSelectedRing] = useState([]);
  const [providerTabThree, setProviderTabThree] = useState([]);
  const { userData } = useUserData();
  const [lastItem, setLastIetm] = useState();
  const [getDataBasket, setGetDataBasket] = useState();
  const [selectedUserContext, setSelectedUserContext] = useState(undefined);
  const [postDataBasket, setPostDataBasket] = useState();
  const [orderItemEditRing, setOrderItemEditRing] = useState(null);
  const [selectedBangle, setSelectedBangle] = useState(null);

  const location = useLocation();

  console.log("amin", selectedUserContext);

  const createHistoryBasket = useFetch({
    method: "post",
    url: "UserBasketHistory_Service",
    data: { ...postDataBasket, provider: selectedUserContext?.id },
    trigger: false,
    argFunc: (res) => {
      let bf = [...userSelectedRing];
      bf[lastItem].history_id = res.id;
      setUserSelectedRing(bf);
    },
    errMessage: (mess) => {
      // toast.error("خطایی رخ داده است", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
  });
  const updateHistoryBasket = useFetch({
    method: "patch",
    url: `UserBasketHistory_Service/${orderItemEditRing}`,
    trigger: false,
    data: { bangle: selectedBangle },
    argFunc: (res) => {
      getHistoryBasket.reFetch();
      // toast.success("سفارش با موفقیت  منتقل شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
    errMessage: (mess) => {
      // toast.error("خطایی رخ داده است", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
  });
  const handleEditRing = (order_item_id, selected_ring) => {
    setOrderItemEditRing(order_item_id);
    setSelectedBangle(selected_ring);
    updateHistoryBasket.reFetch();
  };
  const [selectedHistoryItem, setSelectedHistoryItem] = useState();
  const deleteHistoryBasket = useFetch({
    method: "delete",
    url: `UserBasketHistory_Service/${selectedHistoryItem}`,
    argFunc: (res) => {},
    errMessage: (mess) => {
      // toast.error("خطایی رخ داده است", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
  });
  console.log(userSelectedRing);

  const getHistoryBasket = useFetch({
    method: "post",
    trigger: false,
    url: `User_Service/${userData.username}/get_current_provider_basket`,
    data: { provider: selectedUserContext?.id },

    argFunc: (res) => {
      let a = [];

      res.map((it, ind) => {
        a.push({
          ring: it.bangle,
          nums: showNumSix
            ? [
                it.size_one_num,
                it.size_two_num,
                it.size_three_num,
                it.size_four_num,
                it.size_five_num,
                it.size_six_num,
              ]
            : [
                it.size_one_num,
                it.size_two_num,
                it.size_three_num,
                it.size_four_num,
                it.size_five_num,
              ],
          date: it.date,
          from_hostory: true,
          history_id: it.id,
        });
      });
      if (res.length > 0) {
        setSelectedUserContext(res[0].user);
      }
      setUserSelectedRing(a);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  useEffect(() => {
    if (selectedUserContext !== undefined) {
      getHistoryBasket.reFetch();
    }
  }, [selectedUserContext]);

  const update_admin_producer_ring_nums = (nums, item) => {
    console.log(nums, item);
    const rings = [...providerTabThree];
    let it_ind = rings.findIndex((i) => i.id == item.id);
    // console.log(it_ind.toExponential,rings[it_ind],'111111')

    if (nums[0] !== undefined && nums[0] !== "")
      rings[it_ind]["admin_size_one_num"] =
        rings[it_ind]["admin_size_one_num"] - nums[0] >= 0
          ? rings[it_ind]["admin_size_one_num"] - nums[0]
          : 0;
    if (nums[1] !== undefined && nums[1] !== "")
      rings[it_ind]["admin_size_two_num"] =
        rings[it_ind]["admin_size_two_num"] - nums[1] >= 0
          ? rings[it_ind]["admin_size_two_num"] - nums[1]
          : 0;
    if (nums[2] !== undefined && nums[2] !== "")
      rings[it_ind]["admin_size_three_num"] =
        rings[it_ind]["admin_size_three_num"] - nums[2] >= 0
          ? rings[it_ind]["admin_size_three_num"] - nums[2]
          : 0;
    if (nums[3] !== undefined && nums[3] !== "")
      rings[it_ind]["admin_size_four_num"] =
        rings[it_ind]["admin_size_four_num"] - nums[3] >= 0
          ? rings[it_ind]["admin_size_four_num"] - nums[3]
          : 0;
    if (nums[4] !== undefined && nums[4] !== "")
      rings[it_ind]["admin_size_five_num"] =
        rings[it_ind]["admin_size_five_num"] - nums[4] >= 0
          ? rings[it_ind]["admin_size_five_num"] - nums[4]
          : 0;
    if (nums[5] !== undefined && nums[5] !== "")
      rings[it_ind]["admin_size_six_num"] =
        rings[it_ind]["admin_size_six_num"] - nums[5] >= 0
          ? rings[it_ind]["admin_size_six_num"] - nums[5]
          : 0;

    setProviderTabThree(rings);
  };

  const AddRing = (
    newItem,
    itemNums,
    dateValue,
    selectedUser = null,
    producerCreateOrder = null
  ) => {
    let sz = itemNums.length;
    if (sz == 6) {
      setPostDataBasket({
        bangle: newItem.id,
        size_one_num: itemNums[0] == "" ? 0 : itemNums[0],
        size_two_num: itemNums[1] == "" ? 0 : itemNums[1],
        size_three_num: itemNums[2] == "" ? 0 : itemNums[2],
        size_four_num: itemNums[3] == "" ? 0 : itemNums[3],
        size_five_num: itemNums[4] == "" ? 0 : itemNums[4],
        size_six_num: itemNums[5] == "" ? 0 : itemNums[5],
        date: moment(dateValue).locale("en").format("YYYY-MM-DD"),
        user:
          userData.job == "Admin"
            ? selectedUserContext !== undefined
              ? selectedUserContext.username
              : selectedUser != undefined
              ? selectedUser.username
              : null
            : userData.username,
        // from_admin: props.AdminCreateOrderForUser
      });
    } else {
      setPostDataBasket({
        bangle: newItem.id,
        size_one_num: itemNums[0] == "" ? 0 : itemNums[0],
        size_two_num: itemNums[1] == "" ? 0 : itemNums[1],
        size_three_num: itemNums[2] == "" ? 0 : itemNums[2],
        size_four_num: itemNums[3] == "" ? 0 : itemNums[3],
        size_five_num: itemNums[4] == "" ? 0 : itemNums[4],
        date: moment(dateValue).locale("en").format("YYYY-MM-DD"),
        user:
          userData.job == "Admin"
            ? selectedUserContext !== undefined
              ? selectedUserContext.username
              : selectedUser != undefined
              ? selectedUser.username
              : null
            : userData.username,

        // user:props.selectedUser.username
      });
    }

    let before = [...userSelectedRing];
    if (
      before.some(
        (ri) =>
          ri.ring.id == newItem.id &&
          ri.ring.gender == newItem.gender &&
          newItem.color == ri.ring.color
      )
    ) {
      toast.error("النگو قبلا اضافه شده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      setLastIetm(userSelectedRing.length);

      if (location.state == null) {
        createHistoryBasket.reFetch();
      }

      setUserSelectedRing([
        ...before,
        {
          ring: newItem,
          nums: itemNums,
          date: dateValue,
          from_hostory: false,
          history_id: null,
        },
      ]);
    }

    if (producerCreateOrder) update_admin_producer_ring_nums(itemNums, newItem);
  };
  const removeRing = (ind) => {
    let before = [...userSelectedRing];
    let d = before[ind];
    // if (d.from_hostory) {
    setSelectedHistoryItem(d.history_id);
    deleteHistoryBasket.reFetch();
    // }
    before.splice(ind, 1);
    setUserSelectedRing(before);
  };
  //? data sample
  // [
  //   {
  //     nums:[],
  //     ring:{}
  //   }
  // ]
  const update_admin_producer_ring_num = (ring_id, numIndex, diff) => {
    console.log({ ring_id, numIndex, diff });
    const rings = [...providerTabThree];
    let it_ind = rings.findIndex((i) => i.id == ring_id);
    let key = "";
    if (numIndex == 0) key = "admin_size_one_num";
    if (numIndex == 1) key = "admin_size_two_num";
    if (numIndex == 2) key = "admin_size_three_num";
    if (numIndex == 3) key = "admin_size_four_num";
    if (numIndex == 4) key = "admin_size_five_num";
    if (numIndex == 5) key = "admin_size_six_num";

    rings[it_ind][key] -= diff;
    setProviderTabThree(rings);
  };
  const updateRingNumUsingIndex = (
    ringIndex,
    numIndex,
    newValue,
    producerCreateOrder = null
  ) => {
    let before = [...userSelectedRing];
    // if (producerCreateOrder) {
    //   update_admin_producer_ring_num(
    //     before[ringIndex].ring.id,
    //     numIndex,

    //     before[ringIndex]["nums"][numIndex] - newValue * -1
    //   );
    // }
    before[ringIndex]["nums"][numIndex] = fixNumbers(newValue);

    setUserSelectedRing(before);
  };

  const updateRingDateUsingIndex = (ringIndex, newValue) => {
    let before = [...userSelectedRing];

    before[ringIndex]["date"] = newValue;

    setUserSelectedRing(before);
  };

  const clearBasket = () => {
    setUserSelectedRing([]);
    setSelectedUserContext(undefined);
  };

  return (
    <ProducerBasketContext.Provider
      value={{
        userSelectedRing,
        AddRing,
        removeRing,
        updateRingNumUsingIndex,
        updateRingDateUsingIndex,
        clearBasket,
        selectedUserContext,
        setSelectedUserContext,
        handleEditRing,
        createHistoryBasket,
        setProviderTabThree,
        providerTabThree,
      }}
      {...props}
    >
      {props.children}
    </ProducerBasketContext.Provider>
  );
};
const useProducerBasket = () => React.useContext(ProducerBasketContext);

export { ProducerBasketProvider, useProducerBasket };
